import React from 'react';
import PropTypes from 'prop-types';
import RepeatGroup from './ui/RepeatGroup';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

class LiveEventModalEngagement extends React.Component{

    state = {
        pageLoadTags: this.props.event.pageLoadTags ? this.props.event.pageLoadTags.split(',') : []
    };

    handleChange = (tags, key) => {
        this.setState({[key]: tags});
        this.props.updateEvent(key, tags.join(','));
    };

    render() {
        const durationTracking = this.props.event.durationTracking;
        let durationRepeatGroups = [];
        if(durationTracking){ 
            durationRepeatGroups =  Object.keys(durationTracking).map(duration => {
                if(durationTracking[duration]) {
                    return(
                        <RepeatGroup fieldName="Mins" key={duration} id={duration} keyName={durationTracking[duration].mins || ''} value={durationTracking[duration].tag || ''} onChange={(id, duration) => this.props.updateDuration('durationTracking', id, duration)} onRemove={(id)=> this.props.removeDuration('durationTracking', id)}/>
                    );
                }
                return null;
            });
        } 

        return (
            <div className="tab-panel">
                <div className="column">
                    <label>Tags to drop when page loads</label>
                    <TagsInput value={this.state.pageLoadTags[0] === "" ? [] : this.state.pageLoadTags} onChange={tags => this.handleChange(tags, 'pageLoadTags')} />
                </div>
                <div className="column">
                    <h6>Duration tracking</h6>
                    { durationRepeatGroups }
                    <a onClick={e => this.props.addDuration('durationTracking')} className="btn-add"><i className="material-icons">add_circle_outline</i>Add new</a>
                </div>
            </div>
        );
    }
}

LiveEventModalEngagement.propTypes = {
    event: PropTypes.object.isRequired,
    addDuration: PropTypes.func.isRequired,
    updateDuration: PropTypes.func.isRequired,
    removeDuration: PropTypes.func.isRequired
}

export default LiveEventModalEngagement;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEventModalEngagement.js
 **/